import styled from 'styled-components';
import {
  display,
  dimension,
  position,
  overflow,
  padding,
  margin,
  flexChild,
  flexParent,
  font,
  animation,
} from '../styleHelper2';

const Text = styled.span`
    line-height: 1.4em;
    font-family: Circular;
    ${display()}
    ${dimension()}
    ${position()}
    ${overflow()}
    ${padding()}
    ${margin()}
    ${flexChild()}
    ${flexParent()}
    ${font()}
    ${animation()}
`;

export default Text;
